import { Box } from '@mui/material'
import FleetHomeView from '../Analytics/Dashboard/components/TabView/Views/FleetHomeView'

// Full-width Fleet landing: cancels the main layout's p:3 inset so the dark
// canvas fills the whole pane to the right of the nav, and offsets just below
// the fixed 64px top bar (no boxed container, title sits up against top-left).
const Home = () => {
    return (
        <Box sx={{ width: 'auto', m: -3, pt: '64px' }}>
            <FleetHomeView />
        </Box>
    )
}

export default Home
